import { FooterWellmaxx } from './FooterWellmaxx'

export default FooterWellmaxx
